module.exports = __webpack_public_path__ + "static/00010.4c9bb98e.jpg";